module.exports = __webpack_public_path__ + "static/Hyloq-950b6b5ef627af38071ae386969df6a3.jpg";